import styled from '@emotion/styled';

export const StyledSend = styled.div`
  display: flex;
  align-items: center;

  & .send-off,
  .send-on {
    font-weight: 400;
    font-size: 14px;
  }

  & .send-title {
    margin-right: 40px;
  }
`;

export const StyledItemsFlex = styled.div`
  display: flex;
  align-items: center;
  margin-top: 30px;
  & .send-title {
    margin-right: 100px;
  }
`;

export const SettingWrapper = styled.div`
  display: flex;
  min-width: 1000px;
  align-items: center;
  background: #fff;
  padding: 20px 40px;
  /* padding: 47.65px 40px 46.35px; */
  margin-top: 15px;

  & > strong {
    position: relative;
    display: block;
    width: 200px;
    height: 24px;
    font-size: 16px;
    line-height: 23px;
  }
`;

export const SettingBox = styled.div`
  position: relative;
  width: calc(100% - 232px);
  margin-left: 32px;
  padding-top: 27.65px;
  padding-bottom: 26.35px;

  &:before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: -32px;
    background: #e0e0e0;
  }

  & > :last-child {
    margin-bottom: 0;
  }
`;

export const SettingList = styled.ul`
  position: relative;
  margin-bottom: 30px;
  margin-left: -5px;
  & .send-title {
    margin-right: 40px;
  }

  & > li {
    display: flex;
    white-space: nowrap;
    align-items: center;
    margin-top: 28px;
    font-size: 14px;
    color: #555;
    & > div {
      + span {
        margin-left: 20px;
      }
    }
    & > strong {
      margin-right: 30px;
    }
    & > span {
      + div {
        width: 200px;
      }
    }
    &:first-of-type {
      margin-top: 0;
    }
  }
`;

export const InputList = styled.ul`
  position: relative;
  display: flex;
  align-items: center;

  & li {
    margin-right: 30px;
    & .has-example {
      & div {
        margin-top: 14px;
      }
    }
    & > .example-format {
      display: block;
      margin-top: -6px;
      margin-left: 35px;
      font-size: 12px;
      color: #dbdbdb;
    }
  }
`;
